/* eslint-disable no-constant-condition */
import React from "react";
import { Typography } from "@mui/material";
import "./ChosePetLabel.css";

export const ChosePetLabel = () => {
  return (
    <Typography
      sx={{
        fontSize: "1.2rem",
        fontWeight: false ? "bold" : null,
        color: false ? "secondary.main" : "primary.main",
      }}
    >
      <span className="non-selectable">Tierart</span>
    </Typography>
  );
};
